"use strict";
/*
 * HSTooltip
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@popperjs/core");
var utils_1 = require("../../utils");
var base_plugin_1 = __importDefault(require("../base-plugin"));
var constants_1 = require("../../constants");
var HSTooltip = /** @class */ (function (_super) {
    __extends(HSTooltip, _super);
    function HSTooltip(el, options, events) {
        var _this = _super.call(this, el, options, events) || this;
        if (_this.el) {
            _this.toggle = _this.el.querySelector('.hs-tooltip-toggle') || _this.el;
            _this.content = _this.el.querySelector('.hs-tooltip-content');
            _this.eventMode = (0, utils_1.getClassProperty)(_this.el, '--trigger') || 'hover';
            _this.preventPopper = (0, utils_1.getClassProperty)(_this.el, '--prevent-popper', 'false');
            _this.placement = (0, utils_1.getClassProperty)(_this.el, '--placement');
            _this.strategy = (0, utils_1.getClassProperty)(_this.el, '--strategy');
        }
        if (_this.el && _this.toggle && _this.content)
            _this.init();
        return _this;
    }
    HSTooltip.prototype.init = function () {
        var _this = this;
        this.createCollection(window.$hsTooltipCollection, this);
        if (this.eventMode === 'click') {
            this.toggle.addEventListener('click', function () { return _this.click(); });
        }
        else if (this.eventMode === 'focus') {
            this.toggle.addEventListener('click', function () { return _this.focus(); });
        }
        else if (this.eventMode === 'hover') {
            this.toggle.addEventListener('mouseenter', function () { return _this.enter(); });
            this.toggle.addEventListener('mouseleave', function () { return _this.leave(); });
        }
        if (this.preventPopper === 'false')
            this.buildPopper();
    };
    HSTooltip.prototype.enter = function () {
        this.show();
    };
    HSTooltip.prototype.leave = function () {
        this.hide();
    };
    HSTooltip.prototype.click = function () {
        var _this = this;
        if (this.el.classList.contains('show'))
            return false;
        this.show();
        var handle = function () {
            setTimeout(function () {
                _this.hide();
                _this.toggle.removeEventListener('click', handle, true);
                _this.toggle.removeEventListener('blur', handle, true);
            });
        };
        this.toggle.addEventListener('click', handle, true);
        this.toggle.addEventListener('blur', handle, true);
    };
    HSTooltip.prototype.focus = function () {
        var _this = this;
        this.show();
        var handle = function () {
            _this.hide();
            _this.toggle.removeEventListener('blur', handle, true);
        };
        this.toggle.addEventListener('blur', handle, true);
    };
    HSTooltip.prototype.buildPopper = function () {
        this.popperInstance = (0, core_1.createPopper)(this.toggle, this.content, {
            placement: constants_1.POSITIONS[this.placement] || 'top',
            strategy: this.strategy || 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 5],
                    },
                },
            ],
        });
    };
    // Public methods
    HSTooltip.prototype.show = function () {
        var _this = this;
        this.content.classList.remove('hidden');
        if (this.preventPopper === 'false') {
            this.popperInstance.setOptions(function (options) { return (__assign(__assign({}, options), { modifiers: __spreadArray(__spreadArray([], options.modifiers, true), [
                    {
                        name: 'eventListeners',
                        enabled: true,
                    },
                ], false) })); });
            this.popperInstance.update();
        }
        setTimeout(function () {
            _this.el.classList.add('show');
            _this.fireEvent('show', _this.el);
            (0, utils_1.dispatch)('show.hs.tooltip', _this.el, _this.el);
        });
    };
    HSTooltip.prototype.hide = function () {
        var _this = this;
        this.el.classList.remove('show');
        if (this.preventPopper === 'false') {
            this.popperInstance.setOptions(function (options) { return (__assign(__assign({}, options), { modifiers: __spreadArray(__spreadArray([], options.modifiers, true), [
                    {
                        name: 'eventListeners',
                        enabled: false,
                    },
                ], false) })); });
        }
        this.fireEvent('hide', this.el);
        (0, utils_1.dispatch)('hide.hs.tooltip', this.el, this.el);
        (0, utils_1.afterTransition)(this.content, function () {
            if (_this.el.classList.contains('show'))
                return false;
            _this.content.classList.add('hidden');
        });
    };
    // Static methods
    HSTooltip.getInstance = function (target, isInstance) {
        if (isInstance === void 0) { isInstance = false; }
        var elInCollection = window.$hsTooltipCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element.el
            : null;
    };
    HSTooltip.autoInit = function () {
        if (!window.$hsTooltipCollection)
            window.$hsTooltipCollection = [];
        document.querySelectorAll('.hs-tooltip').forEach(function (el) {
            if (!window.$hsTooltipCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; }))
                new HSTooltip(el);
        });
    };
    HSTooltip.show = function (target) {
        var elInCollection = window.$hsTooltipCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (elInCollection) {
            switch (elInCollection.element.eventMode) {
                case 'click':
                    elInCollection.element.click();
                    break;
                case 'focus':
                    elInCollection.element.focus();
                    break;
                default:
                    elInCollection.element.enter();
                    break;
            }
        }
    };
    HSTooltip.hide = function (target) {
        var elInCollection = window.$hsTooltipCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (elInCollection)
            elInCollection.element.hide();
    };
    // Backward compatibility
    HSTooltip.on = function (evt, target, cb) {
        var elInCollection = window.$hsTooltipCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (elInCollection)
            elInCollection.element.events[evt] = cb;
    };
    return HSTooltip;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSTooltip.autoInit();
    // Uncomment for debug
    // console.log('Tooltip collection:', window.$hsTooltipCollection);
});
if (typeof window !== 'undefined') {
    window.HSTooltip = HSTooltip;
}
exports.default = HSTooltip;
